import { OrangeCrmPlugin } from "./orange_crm/orangeCrmPlugin";
import { OrangeCrmOmniPlugin } from "./orange_crm_omni/orangeCrmOmniPlugin";
import { Plugin, PluginContext } from "./plugin";
import { SalesforcePlugin } from "./salesforce/salesforcePlugin";

export type PluginsConfiguration = { [id: string]: any };

export class PluginRegistry {
  private readonly plugins: Map<string, Plugin> = new Map();
  private active: Plugin[] = [];

  constructor() {
    this.register(new SalesforcePlugin());
    this.register(new OrangeCrmOmniPlugin());
    this.register(new OrangeCrmPlugin());
  }

  configure(context: PluginContext, config: PluginsConfiguration) {
    this.active = [];
    if (!config) {
      return;
    }
    Object.keys(config).forEach((id) => {
      const plugin = this.plugins.get(id);
      if (plugin) {
        plugin.configure(context, config[id]);
        this.active.push(plugin);
      }
    });
  }

  get activePlugins(): Plugin[] {
    return this.active;
  }

  private register(plugin: Plugin) {
    this.plugins.set(plugin.id, plugin);
  }
}
